import { CommitGoal } from "../../learning-path/pages/commit-goal/commit-goal.component";
import { CompletedPage } from "../../learning-path/pages/completed-page/completed-page.component";
import { Discover } from "../../learning-path/pages/discover/discover.component";
import { Quickwins } from "../../learning-path/pages/quickwins/quickwins.component";
import { Workout } from "../../learning-path/pages/workout/workout.component";
import type { MxQuickWin } from "../../models/gameplan";
import { GamePlanItemType, type GamePlanPath } from "./use-game-plan";

interface ItemDisplayProps {
  gamePlan: GamePlanPath;
  isGamePlanCompleted: boolean | undefined;
  isLearningPathStarted?: boolean | undefined;
  isLearningPathFinished?: boolean | undefined;
  setMxQuickWin: (quickWin: MxQuickWin) => void;
}

export const ItemDisplay = ({
  gamePlan,
  isGamePlanCompleted,
  isLearningPathStarted,
  isLearningPathFinished,
  setMxQuickWin,
}: ItemDisplayProps) => {
  const componentToRender = () => {
    switch (gamePlan?.type) {
      case GamePlanItemType.COMMITMENT:
        return <CommitGoal />;
      case GamePlanItemType.WORKOUT:
        return <Workout gamePlan={gamePlan} />;
      case GamePlanItemType.DISCOVER:
        return (
          <Discover
            key={gamePlan.index}
            gamePlan={gamePlan}
            isLearningPathStarted={isLearningPathStarted}
          />
        );
      case GamePlanItemType.COMPLETED:
        return (
          <CompletedPage
            gamePlan={gamePlan}
            isGamePlanCompleted={isGamePlanCompleted}
            isLearningPathFinished={isLearningPathFinished}
          />
        );
      case GamePlanItemType.QUICKWIN:
        return <Quickwins onQuickWinClick={setMxQuickWin} />;
    }
  };

  return <>{componentToRender()}</>;
};
